module.exports = __webpack_public_path__ + "media/assets/images/caret-right-white-09653f0bade76c57df0fb6ad214f1ea0.svg";